import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRadio } from 'vuetify/lib/components/VRadioGroup';
import { VRadioGroup } from 'vuetify/lib/components/VRadioGroup';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VTextField } from 'vuetify/lib/components/VTextField';
import { VTextarea } from 'vuetify/lib/components/VTextarea';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('span', [_c('p', {
    staticClass: "card-description mt-4"
  }, [_vm._v(_vm._s(_vm.$i18n_t('DigitalTwin.DigitalTwin.states.valueText')))]), _c(VRow, [_c(VCol, {
    staticClass: "mb-0",
    attrs: {
      "cols": "12",
      "sm": "3"
    }
  }, [_c(VSelect, {
    attrs: {
      "items": _vm.typeItems,
      "disabled": _vm.mode === 'readonly',
      "color": _vm.color,
      "outlined": _vm.inpOutlined,
      "filled": _vm.inpFilled,
      "label": _vm.$i18n_t('DigitalTwin.DigitalTwin.states.valueType'),
      "required": "",
      "hide-details": "",
      "data-cy": "states_valueType"
    },
    on: {
      "input": _vm.cleanupBooleanValue
    },
    model: {
      value: _vm.lclModel.properties.valueType,
      callback: function ($$v) {
        _vm.$set(_vm.lclModel.properties, "valueType", $$v);
      },
      expression: "lclModel.properties.valueType"
    }
  })], 1), !_vm.skipValueSaving && _vm.lclModel.properties.valueType === 'boolean' && !_vm.templateContext ? _c(VCol, {
    staticClass: "mb-0",
    attrs: {
      "cols": "6",
      "sm": "9"
    }
  }, [_c(VRadioGroup, {
    staticClass: "mt-0",
    attrs: {
      "column": "",
      "hide-details": "",
      "disabled": _vm.mode === 'readonly' && !_vm.stateEditable
    },
    on: {
      "change": _vm.valueFieldEdited
    },
    model: {
      value: _vm.lclModel.value.value,
      callback: function ($$v) {
        _vm.$set(_vm.lclModel.value, "value", $$v);
      },
      expression: "lclModel.value.value"
    }
  }, [_c(VRadio, {
    attrs: {
      "label": "true",
      "data-cy": "radio-true",
      "value": true,
      "color": _vm.color,
      "hide-details": ""
    },
    on: {
      "mouseup": _vm.clickedBoolRadio
    }
  }), _c(VRadio, {
    attrs: {
      "label": "false",
      "data-cy": "radio-false",
      "value": false,
      "color": _vm.color,
      "hide-details": ""
    },
    on: {
      "mouseup": _vm.clickedBoolRadio
    }
  }), _c(VRadio, {
    attrs: {
      "label": _vm.$i18n_t('DigitalTwin.DigitalTwin.states.valueIsNull'),
      "data-cy": "radio-null",
      "value": null,
      "color": _vm.color,
      "hide-details": ""
    },
    on: {
      "mouseup": _vm.clickedBoolRadio
    }
  })], 1)], 1) : !_vm.skipValueSaving ? _c(VCol, {
    staticClass: "mb-0",
    attrs: {
      "cols": "12",
      "sm": "9"
    }
  }, [_vm.lclModel.properties.valueType === 'json' ? _c('div', [!_vm.templateContext ? _c(VTextarea, {
    attrs: {
      "color": _vm.color,
      "value": _vm.stateValue,
      "disabled": _vm.mode === 'readonly',
      "outlined": _vm.inpOutlined,
      "filled": _vm.inpFilled,
      "label": _vm.$i18n_t('DigitalTwin.DigitalTwin.states.value'),
      "required": "",
      "hide-details": "",
      "inset": "",
      "rules": _vm.jsonRule,
      "data-cy": "states_value_json"
    },
    on: {
      "input": _vm.valueFieldEdited
    }
  }) : _vm._e(), _vm.jsonErrorMsg ? _c('p', {
    staticClass: "mt-1 error--text"
  }, [_vm._v(_vm._s(_vm.jsonErrorMsg))]) : _vm._e()], 1) : !_vm.templateContext ? _c(VTextField, {
    attrs: {
      "disabled": _vm.mode === 'readonly' && !_vm.stateEditable,
      "color": _vm.color,
      "outlined": _vm.inpOutlined,
      "filled": _vm.inpFilled,
      "label": _vm.$i18n_t('DigitalTwin.DigitalTwin.states.value'),
      "type": "text",
      "required": "",
      "hide-details": "",
      "data-cy": "states_value"
    },
    on: {
      "input": _vm.valueFieldEdited
    },
    model: {
      value: _vm.lclModel.value.value,
      callback: function ($$v) {
        _vm.$set(_vm.lclModel.value, "value", $$v);
      },
      expression: "lclModel.value.value"
    }
  }) : _vm._e()], 1) : _vm._e()], 1), _c(VRow, [!_vm.templateContext ? _c(VCol, {
    class: 'mb-0' + (_vm.lclModel.properties.valueType !== 'boolean' ? ' mt-0 pt-0' : ''),
    attrs: {
      "cols": "12",
      "sm": "9",
      "md": "6"
    }
  }, [_c(VCheckbox, {
    attrs: {
      "disabled": _vm.mode === 'readonly' && !_vm.stateEditable,
      "color": _vm.color,
      "label": _vm.$i18n_t('DigitalTwin.DigitalTwin.states.skipValueSaving'),
      "outlined": "",
      "hide-details": ""
    },
    model: {
      value: _vm.skipValueSaving,
      callback: function ($$v) {
        _vm.skipValueSaving = $$v;
      },
      expression: "skipValueSaving"
    }
  }), _c('p', {
    staticClass: "card-description",
    domProps: {
      "innerHTML": _vm._s(_vm.$i18n_t('DigitalTwin.DigitalTwin.states.skipValueSavingText'))
    }
  })], 1) : _vm._e(), !_vm.skipValueSaving && _vm.valueWasChanged && _vm.isSuperSystemAdmin && !_vm.templateContext ? _c(VCol, {
    attrs: {
      "cols": "12",
      "sm": "9",
      "md": "6"
    }
  }, [_c(VTextField, {
    attrs: {
      "disabled": _vm.mode === 'readonly',
      "color": _vm.color,
      "outlined": _vm.inpOutlined,
      "filled": _vm.inpFilled,
      "label": "Update Timestamp (UTC)",
      "type": "text",
      "required": "",
      "hide-details": ""
    },
    model: {
      value: _vm.lclModel.value.time,
      callback: function ($$v) {
        _vm.$set(_vm.lclModel.value, "time", $$v);
      },
      expression: "lclModel.value.time"
    }
  })], 1) : _vm._e(), !_vm.skipValueSaving && _vm.valueWasChanged && !_vm.templateContext ? _c(VCol, {
    staticClass: "my-0 pt-0",
    attrs: {
      "cols": "12",
      "sm": "9",
      "md": "6"
    }
  }, [_c(VCheckbox, {
    attrs: {
      "disabled": _vm.mode === 'readonly' && !_vm.stateEditable,
      "color": _vm.color,
      "label": _vm.$i18n_t('DigitalTwin.DigitalTwin.states.skipTransformer'),
      "outlined": "",
      "hide-details": ""
    },
    model: {
      value: _vm.skipTransformer,
      callback: function ($$v) {
        _vm.skipTransformer = $$v;
      },
      expression: "skipTransformer"
    }
  }), _c('p', {
    staticClass: "card-description",
    domProps: {
      "innerHTML": _vm._s(_vm.$i18n_t('DigitalTwin.DigitalTwin.states.skipTransformerText'))
    }
  })], 1) : _vm._e()], 1)], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };